<div class="wrapper">
  <div class="dialog-header">
    Display FIAT currency
    <div class="onact96">
      <i class="fi-x" (click)="dialogRef.close()"></i>
    </div>
  </div>
  <div class="dialog-body">
    This will change your default FIAT display currency. You can update this at any time in your settings page.
    <cs-select [(value)]="currentFiat" [options]="fiatOptions"></cs-select>
    <cs-button [label]="'Save'" [size]="'large'" (buttonClick)="onSave()"></cs-button>
  </div>
</div>
